import React, { Component } from 'react';
import primalLogo from '../assets/PrimalIcon.png';
import { auth } from '../AuthService';
import LoginModal from '../LoginModal/LoginModal';

const navLinkStyle = {
  backdropFilter: "blur(16px)",
  backgroundColor: "rgba(0, 0, 0, .05)",
  color: "rgb(255, 186, 6)"
};

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      user: null,
      showLoginModal: false,
      showAccountDropdown: false,
    };
  }

  componentDidMount() {
    if (auth.loggedIn()) {
      this.setState({ isLoggedIn: true, user: auth.getUser() });
    }
    window.addEventListener("authChange", this.handleAuthChange);
  }

  componentWillUnmount() {
    window.removeEventListener("authChange", this.handleAuthChange);
  }

  handleAuthChange = () => {
    if (auth.loggedIn()) {
      this.setState({ isLoggedIn: true, user: auth.getUser() });
    } else {
      this.setState({ isLoggedIn: false, user: null, showAccountDropdown: false });
    }
  }

  handleSignOut = () => {
    auth.logout();
    this.setState({ isLoggedIn: false, user: null, showAccountDropdown: false });
    window.dispatchEvent(new Event("authChange"));
  }

  handleLoginSuccess = (userData) => {
    this.setState({
      isLoggedIn: true,
      user: auth.getUser(),
      showLoginModal: false,
    });
    window.dispatchEvent(new Event("authChange"));
  }

  render() {
    const { isLoggedIn, user, showLoginModal, showAccountDropdown } = this.state;

    return (
      <div className="row">
      <div className="col-md-12 col-xs-12">
        <nav className="navbar navbar-expand-lg fixed-top navbar-transparent nav-down">
            <a className="navbar-brand" href="/"><img alt="Primal Trading Card Game Logo" src={primalLogo} /></a>
            <button style={{
                backdropFilter: "blur(16px)",
                backgroundColor: "rgba(0, 0, 0, .05)"
              }} className="navbar-toggler navbar-toggler-right"
              type="button" data-toggle="collapse" data-target="#navbar-menu" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <p style={{
                fontWeight: "bold",
                color: "rgb(255, 186, 6)"
              }}>Menu</p>
            </button>
            <div className="collapse navbar-collapse" id="navbar-menu">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <a style={navLinkStyle} className="nav-link" href="/search">Card Search</a>
                </li>
                <li className="nav-item">
                  <a style={navLinkStyle} className="nav-link" href="/build">Deck Builder</a>
                </li>
                <li className="nav-item">
                  <a style={navLinkStyle} className="nav-link" href="/decks">Community Decks</a>
                </li>
                <li className="nav-item">
                  <a style={navLinkStyle} className="nav-link" href="https://shop.primaltcg.com">Buy Primal TCG</a>
                </li>
                <li className="nav-item dropdown">
                  <a style={navLinkStyle} className="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Play & Rules</a>
                  <ul className="dropdown-menu dropdown-menu-right dropdown-warning">
                  <div className="dropdown-header">Organized Play</div>
                    <a className="dropdown-item" href="https://play.primaltcg.com">Primal Play Network</a>
                    <div className="dropdown-header">Rulebooks</div>
                    <a className="dropdown-item" href="https://docs.google.com/document/d/1Um3-j4f_O0Q4T6rbvw-ItVrFFDOR2gs9XeT9xYDvSc4/edit?usp=sharing">Comprehensive Rulebook</a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item"href="/rulebook">General Rulebook</a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item"href="https://docs.google.com/document/d/1_Qktc3NAbwpxCt_Ikwe-037BcpyQ75RyYEFR2qFm-0g/edit?usp=sharing">Tournament Policy</a>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a style={navLinkStyle} className="nav-link dropdown-toggle" data-toggle="dropdown" href="/#Contact" role="button" aria-haspopup="true" aria-expanded="false">Contact</a>
                  <ul className="dropdown-menu dropdown-menu-right dropdown-warning">
                    <div className="dropdown-header">Contact</div>
                    <a className="dropdown-item" href="/#contact-us">Message Us</a>
                    <div className="dropdown-divider"></div>
                  </ul>
                </li>

                {isLoggedIn && user ? (
                  <li className="nav-item dropdown" style={{ position: "relative" }}>
                    <a style={{
                      ...navLinkStyle,
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                    }} className="nav-link"
                      onClick={() => this.setState(prev => ({ showAccountDropdown: !prev.showAccountDropdown }))}>
                      <span style={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#4caf50",
                        flexShrink: 0,
                      }} />
                      {user.username}
                      <span style={{ fontSize: "0.55rem", marginLeft: "2px", opacity: 0.7 }}>{showAccountDropdown ? "\u25B2" : "\u25BC"}</span>
                    </a>
                    {showAccountDropdown && <>
                      <div
                        style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1049 }}
                        onClick={() => this.setState({ showAccountDropdown: false })}
                      />
                      <div style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        minWidth: "160px",
                        padding: "10px 0",
                        backgroundColor: "#fff",
                        border: "0 solid transparent",
                        borderRadius: "12px",
                        boxShadow: "1px 1px 20px 0px rgba(0,0,0,0.1)",
                        zIndex: 1050,
                      }}>
                        <div style={{ padding: "3px 20px", fontSize: "0.7142em", fontWeight: 700, color: "#9A9A9A", textTransform: "uppercase" }}>Account</div>
                        <a
                          href="#"
                          onClick={(e) => { e.preventDefault(); this.handleSignOut(); }}
                          style={{
                            display: "block",
                            padding: "3px 20px",
                            color: "#212529",
                            textDecoration: "none",
                            fontSize: "14px",
                            lineHeight: "1.5",
                          }}
                          onMouseEnter={(e) => { e.target.style.backgroundColor = "rgb(255, 186, 6)"; e.target.style.color = "#1a1a2e"; }}
                          onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#212529"; }}
                        >
                          Sign Out
                        </a>
                      </div>
                    </>}
                  </li>
                ) : (
                  <li className="nav-item">
                    <a
                      style={{
                        ...navLinkStyle,
                        fontWeight: 700,
                        cursor: "pointer",
                        border: "1px solid rgb(255, 186, 6)",
                        borderRadius: "6px",
                        padding: "6px 16px",
                        marginLeft: "8px",
                        transition: "background 0.15s, color 0.15s",
                      }}
                      className="nav-link"
                      onClick={(e) => { e.preventDefault(); this.setState({ showLoginModal: true }); }}
                      onMouseEnter={(e) => { e.target.style.backgroundColor = "rgb(255, 186, 6)"; e.target.style.color = "#1a1a2e"; }}
                      onMouseLeave={(e) => { e.target.style.backgroundColor = "rgba(0, 0, 0, .05)"; e.target.style.color = "rgb(255, 186, 6)"; }}
                    >
                      Sign In
                    </a>
                  </li>
                )}
              </ul>
            </div>
        </nav>
      </div>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => this.setState({ showLoginModal: false })}
        onLoginSuccess={this.handleLoginSuccess}
        title="Sign in to your account"
        subtitle="Sign in to save decks, share with the community, and more."
        darkMode={localStorage.getItem("searchPageTheme") !== "light"}
      />
    </div>
    );
  }
}
